<div class="portal">
  <header class="portal-header">
    <div class="portal-header-inner">
      <div class="portal-header-top">
        <button type="button" class="client-logo" (click)="closeDetail()">
          <img *ngIf="logoUrl" class="logo-img" [src]="logoUrl" [alt]="clientName" />
          <div *ngIf="!logoUrl" class="mark">{{ initials }}</div>
          <div class="name" *ngIf="!logoUrl">{{ clientName }}</div>
        </button>
        <div class="brand-banners" *ngIf="logoUrl">
          <div class="brand-banner welcome">Welcome to the {{ clientName }}</div>
          <div class="brand-banner title">{{ portalLabel }} Portal</div>
        </div>
      </div>
      <div class="header-tabs" *ngIf="!selected">
        <button type="button" [class.active]="tab === 'all'" (click)="tab = 'all'">All policies</button>
        <button type="button" [class.active]="tab === 'recent'" (click)="tab = 'recent'">Recently updated</button>
      </div>
    </div>
  </header>

  <ng-container *ngIf="!selected">
    <div class="hero">
      <p *ngIf="tab === 'recent'">Policies updated in the last 90 days, newest first.</p>
      <p *ngIf="tab !== 'recent' && view === 'list'">
        Browse, search, and download the city's official policies. Every document is the current approved version.
      </p>
      <p *ngIf="tab !== 'recent' && view === 'grouped'">
        Same library, organized by folder for cities that prefer groups over a flat list.
      </p>
    </div>

    <div class="search-row">
      <div class="search-box">
        <span class="material-icons">search</span>
        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Search policies… e.g. “remote work”, “purchasing”, “records”"
        />
        <div class="view-toggle">
          <button type="button" title="List view" [class.active]="view === 'list'" (click)="view = 'list'">
            <span class="material-icons">view_list</span>
          </button>
          <button type="button" title="Grouped view" [class.active]="view === 'grouped'" (click)="view = 'grouped'">
            <span class="material-icons">folder</span>
          </button>
        </div>
      </div>
    </div>

    <div class="body-wrap">
      <div class="main-col">
        <div class="chip-rail" *ngIf="view === 'list'">
          <button
            type="button"
            class="chip"
            *ngFor="let chip of chips"
            [class.active]="category === chip.name"
            (click)="selectCategory(chip.name)"
          >
            <span class="material-icons">{{ chip.icon }}</span>
            {{ chip.name }}
            <span class="count">{{ chip.count }}</span>
          </button>
        </div>

        <p class="empty" *ngIf="loadError">{{ loadError }}</p>
        <p class="empty" *ngIf="!loadError && visibleDocuments.length === 0">
          {{ tab === 'recent' && !searchText ? 'No policies were updated in the last 90 days.' : 'No policies match this search.' }}
        </p>

        <div class="policy-list" *ngIf="view === 'list'">
          <ng-container *ngFor="let document of visibleDocuments">
            <ng-container *ngTemplateOutlet="policyRow; context: { $implicit: document }"></ng-container>
          </ng-container>
        </div>

        <div *ngIf="view === 'grouped'">
          <div class="folder-group" *ngFor="let group of groups">
            <button type="button" class="folder-header" (click)="toggleGroup(group.name)">
              <span class="material-icons">{{ isGroupOpen(group.name) ? 'expand_more' : 'chevron_right' }}</span>
              {{ group.name }} ({{ group.documents.length }})
            </button>
            <div class="folder-body" *ngIf="isGroupOpen(group.name)">
              <ng-container *ngFor="let document of group.documents">
                <ng-container *ngTemplateOutlet="policyRow; context: { $implicit: document, hideCategory: true }"></ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <aside class="side-col">
        <div class="side-card">
          <h4>Recently updated</h4>
          <button
            type="button"
            class="up-item"
            *ngFor="let document of recentDocuments"
            (click)="openDocument(document)"
          >
            <span>{{ document.name }}</span>
            <span class="d">{{ updatedLabel(document, 'short') }}</span>
          </button>
          <p class="empty" *ngIf="recentDocuments.length === 0">No documents yet.</p>
        </div>
      </aside>
    </div>
  </ng-container>

  <div class="detail-wrap" *ngIf="selected">
    <div class="crumbs">
      <button type="button" (click)="closeDetail()">Policies</button>
      <span>›</span>
      <span>{{ selected.category }}</span>
      <span>›</span>
      <span>{{ selected.name }}</span>
    </div>

    <div class="detail-head">
      <h1>{{ selected.name }}</h1>
      <div class="detail-actions">
        <button type="button" class="btn btn-primary" (click)="download(selected)">
          <span class="material-icons">download</span> Download PDF
        </button>
      </div>
    </div>

    <!-- Version, approval, and labels print in the PDF's own header; only Last updated is portal-specific. -->
    <div class="detail-meta" *ngIf="updatedLabel(selected)">
      <div class="m-item">
        <div class="l">Last updated</div>
        <div class="v">{{ updatedLabel(selected) }}</div>
      </div>
    </div>

    <div class="doc-body pdf-frame" *ngIf="pdfSrc">
      <ngx-extended-pdf-viewer
        [src]="pdfSrc"
        [showToolbar]="true"
        [showSidebarButton]="false"
        [sidebarVisible]="false"
        [showSecondaryToolbarButton]="false"
        [showDownloadButton]="false"
        [showPrintButton]="true"
        [textLayer]="true"
        [zoom]="'page-width'"
        backgroundColor="#ffffff"
        height="calc(100vh - 240px)"
      ></ngx-extended-pdf-viewer>
    </div>

    <div class="doc-body" *ngIf="selected.type !== 'File'">
      <table class="version-table">
        <thead>
          <tr>
            <th>Version</th>
            <th>Date</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><span class="vbadge">{{ selected.versionLabel || 'Current' }}</span></td>
            <td>{{ updatedLabel(selected) || '—' }}</td>
            <td>{{ selected.summary || 'Current approved version.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>

<ng-template #policyRow let-document let-hideCategory="hideCategory">
  <div class="policy-row" (click)="openDocument(document)">
    <div class="icon"><span class="material-icons">description</span></div>
    <div class="main">
      <div class="title">{{ document.name }}</div>
      <div class="meta">
        <span class="cat-tag" *ngIf="!hideCategory">{{ document.category }}</span>
        {{ metaLine(document) }}
      </div>
    </div>
    <div class="row-actions">
      <button type="button" class="icon-btn" title="View" (click)="openDocument(document); $event.stopPropagation()">
        <span class="material-icons">visibility</span>
      </button>
      <button type="button" class="icon-btn" title="Download PDF" (click)="download(document, $event)">
        <span class="material-icons">download</span>
      </button>
    </div>
  </div>
</ng-template>
